module.exports = __webpack_public_path__ + "img/agh.ce86cba8.jpg";